<template>
  <widget-container
      headlineclass
      cardclass=" ma-0 pa-1"
      :url="url"
      :bus="bus"
      :dark="false"
      :flat="false"
      color="transparent"
      :alwaysrender="true"
      @ready="setData"
  >
    <template slot="content">
      <div class>
        <div :style="'overflow-x: auto;margin:auto;' ">
          <v-row align="center">
            <v-col class="mb-3 text-right">
              <v-btn @click="copy" small depressed :disabled="this.table.items.length==0">
                <v-icon small>mdi-clipboard-outline</v-icon>
                Copier
              </v-btn>
            </v-col>
          </v-row>
          <div :style="'width:'+tableWidth+'px;border: 1px solid #e1e1e1;margin:auto;'" class="mb-6">
            <v-data-table
                v-model="table.items"
                :headers="table.headers"
                :items="table.items"
                :loading="table.loading"
                :items-per-page="1000"
                hide-default-footer
                no-data-text="Aucun message en attente"
            >

              <template v-for="(header,i) in table.headers" v-slot:[`item.${header.value}`]="{ item }">

                <div v-bind:key="header+'_'+i">
                  <span>{{ getItemValue(header, item) }}</span>
                </div>
              </template>

              <template #foot>
                <tr class="font-weight-medium" v-if="table.total != null" style="border-bottom: 1px solid #e1e1e1;">
                  <td class=" font-weight-medium body-1 pl-4 py-2 mr-6">{{ table.total.hotel }}</td>
                  <td v-for="(year,i) in table.total.years" :key="'_'+i+year" class="body-1 pl-4 font-weight-medium">
                    {{ year.value }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
    </template>
  </widget-container>
</template>

<script>
import WidgetContainer from "./WidgetContainer";
import clipboard from "../../../utils/clipboard";
import _ from "lodash";


export default {
  name: "WidgetNightsPerYear",
  components: {WidgetContainer},
  mixins: [],
  props: {
    bus: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    withLastYear: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      table: {
        loading: false,
        items: [],
        rowsPerPageItems: [{text: "Tous", value: -1}],
        headers: [],
        total: null,
      },
    };
  },
  created() {
    this.$nextTick(() => {
      this.bus.$on("search", (searchform) => {
        this.table.loading = true;
      });
    });
  },
  destroyed() {
    this.bus.$off("search");
  },
  watch: {},
  computed: {
    tableWidth() {
      if (this.table.headers.length > 0) {
        const width = this.table.headers
            .map((h) => (this.withLastYear ? h.fullSize : h.smallSize))
            .reduce((acc, curr) => acc + curr);
        return width;
      } else return 800;
    },
  },
  methods: {
    setData(data) {

      this.table.loading = true;
      this.table.headers = [
        {text: "Hôtel", fullSize: 180, smallSize: 180, value: "hotel"},
        ...data.headers.map((year) => {
              return {
                text: year,
                fullSize: 150,
                smallSize: 150,
                value: year,
              }
            }
        ),
      ];

      this.table.items = data.items
      this.table.total = {
        hotel: "Total:",
        hotelId: 0,
        years: data.total.map(t => t.nights)
      }

      this.table.loading = false
    },
    getItemValue(header, item) {
      const val = item.years.find(year => year.name === header.value.toString())

      if (header.value === 'hotel') {
        return item.hotel
      } else {
        return val != null ? val.value : ''
      }

    },
    sort(header, index) {
      const asc = "asc";
      const desc = "desc";

      this.table.headers = this.table.headers.map((h) => {
        h.sorted = !h.sorted
            ? "asc"
            : h.sorted && h.sorted == "asc"
                ? "desc"
                : null;
        return h;
      });

      if (header.sorted) {
        const isDescending = header.sorted == "desc";
        const items = _.cloneDeep(this.table.items);
        items.sort((a, b) => {
          const aValue =
              typeof a[header.value] == "string"
                  ? a[header.value]
                  : a[header.value][index].nights.value;
          const bValue =
              typeof b[header.value] == "string"
                  ? b[header.value]
                  : b[header.value][index].nights.value;

          if (typeof aValue == "number" && typeof bValue == "number")
            return isDescending ? bValue - aValue : aValue - bValue;
          else
            return isDescending
                ? bValue.localeCompare(aValue)
                : aValue.localeCompare(bValue);
        });

        this.table.items = items;
      }
    },
    copy() {
      const defaultSeparator = "\t";

      const buildCell = (item) => {
        return `${
            item && item.value
                ? item.value
                : 0
        }${defaultSeparator}`;
      };

      const headers = this.table.headers
          .map((h) => {
            return `${h.value}${defaultSeparator} ${
                !this.withLastYear ? "" : defaultSeparator
            }`;
          })
          .join(" ");

      const rows = this.table.items.map((i) => {
        const cell = i.years
            .map((m) => {
              return buildCell(m);
            })
            .join(" ");

        return `${i.hotel}${defaultSeparator}${cell}`;
      });

      const total = this.table.total.years.map((i) => {
        return buildCell(i);
      })
      const totalRow = [this.table.total.hotel]

      totalRow.push([...total].join(" "))

      const allRows = [headers].concat(rows, totalRow.join("\t "));

      clipboard.copyTextToClipboard(allRows.join("\n"));
    },
  },
};
</script>

<style scoped>
>>> .theme--light.v-data-table tbody tr.v-data-table__selected {
  background: white;
}

</style>
